import { useQuery } from '@tanstack/react-query';
import React from 'react';
import toast from 'react-hot-toast';

const AllUsers = () => {

    const { data: users = [], refetch } = useQuery({
        queryKey: ['users'],
        queryFn: async () => {
            const res = await fetch('https://doctor-portal-server-nu.vercel.app/users')
            const data = res.json()
            return data;
        }
    })


    const handleMakeAdmin = id => {
        // console.log(id);
        fetch(`https://doctor-portal-server-nu.vercel.app/users/admin/${id}`, {
            method: 'PUT',
            headers: {
                authorization: `Bearer ${localStorage.getItem('access-Token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.modifiedCount) {
                    toast.success('Update Successful')
                    refetch();
                }
            })
    }


    return (
        <div className="overflow-x-auto">
            <table className="table w-full">
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Admin</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        users.map((user, index) =>
                            <tr key={user._id}>
                                <th>{index + 1}</th>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{
                                    user?.role !== 'admin' ? <button onClick={() => handleMakeAdmin(user?._id)} className='btn btn-xs btn-primary'>Make Admin</button>
                                        :
                                        <button className='text-success font-semibold'>Admin</button>
                                }</td>
                                <td><button className='btn btn-xs btn-error'>Delete</button></td>
                            </tr>)
                    }
                </tbody>
            </table>
        </div>
    );
};

export default AllUsers;